import { Typography } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'

import useStyles from './styles/statusBox.styles'

interface BookingListAddFilterButtonProps {
  status:
    | 'Started'
    | 'FinishedSuccessfully'
    | 'InProgress'
    | 'FinishedWithError'
}

const StatusBox: React.FC<BookingListAddFilterButtonProps> = ({ status }) => {
  const classes = useStyles()
  const getColorForStatus = (
    s: 'Started' | 'FinishedSuccessfully' | 'InProgress' | 'FinishedWithError'
  ) => {
    switch (s) {
      case 'FinishedWithError':
        return 'red'
        break

      case 'FinishedSuccessfully':
        return 'green'
        break

      case 'Started':
        return 'grey'
        break

      case 'InProgress':
        return 'blue'
        break

      default:
        break
    }
  }
  return (
    <div className={classes.root}>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.red].join(' ')}>
          <span>{status}</span>
          <ErrorIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.green].join(' ')}>
          <span>{status}</span>
          <CheckCircleIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'blue' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.blue].join(' ')}>
          <span>{status}</span>
          <InfoIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'grey' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.grey].join(' ')}>
          <span>{status}</span>
          <CancelIcon />
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
